import axios from "../axios";

export const getAgeGroup = async(value) => {
   
   const {data} = await axios.get(`students/${value}`)
  
   return data
}